import { Tab } from '@/types'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  tabs: Tab
  setTabs: Dispatch<SetStateAction<Tab | null>>
}

export const Tabs = ({ tabs, setTabs }: Props) => {
  const { t } = useTranslation()

  const handleClick = (key: string) => {
    const newTabs = { ...tabs }

    newTabs[key].tabIsUse = true

    for (const tabKey in newTabs) {
      if (tabKey !== key) {
        newTabs[tabKey].tabIsUse = false
      }
    }

    setTabs(newTabs)
  }

  return (
    <div className="flex overflow-x-auto">
      {Object.entries(tabs).map((tab: [string, { tabIsUse: boolean; isShow?: boolean }]) => {
        const [key, value] = tab

        return (
          <div
            className={`flex relative px-4 pt-4 pb-2 items-center justify-center text-sm text-center text-white font-semibold cursor-pointer ${
              !value.isShow && 'hidden'
            } ${value.tabIsUse ? '' : 'text-opacity-50'}`}
            key={key}
            onClick={() => handleClick(key)}
          >
            {t(`common.${key}`)}
            <div
              className={`absolute w-full bg-white top-0 ${
                value.tabIsUse ? 'h-1' : 'h-0 opacity-0'
              } rounded-br-lg rounded-bl-lg transition-all duration-300 ease-in-out`}
            />
          </div>
        )
      })}
    </div>
  )
}
